export const DEVELOPMENT = true;
export const TESTING = true;

const globals = {
  majorVersion: '7',
  minorVersion: '1.0'
}

export default globals;